import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({standalone: true, name: 'datatypeValuePipe'})
export class DatatypeValuePipe implements PipeTransform
{
  private translate = inject(TranslateService);

  transform(value: string): string
  {
    if (value === 'true')
      return this.translate.instant('YES');
    else if (value === 'false')
      return this.translate.instant('NO');

    return value;
  }
}
